import React from 'react';
import { Grid } from '@mui/material';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import { PageContainer } from '../../../../../../components/atoms/PageContainer';
import { Accordian } from '../../../../../../components/atoms/Accordian';
import { Typography } from '../../../../../../components/atoms/Typography';
import { DataGrid } from '../../../../../../components/atoms/DataGrid';
import { Link } from '../../../../../../components/atoms/Link';
import { IncomingShipmentListFragmentProps } from './IncomingShipmentListFragment.props';
import { formatDateOnly } from '../../../../../../utils/common';
import { DatagridSortingTypes } from '../../../../../../@types';
import { GridContainer } from './IncomingShipmentListFragment.styles';

export const IncomingShipmentListFragment: React.FC<IncomingShipmentListFragmentProps> = ({
  incomingShipments,
  selectedShipmentId,
  isLoading
}) => {
  const columns: GridColDef[] = [
    {
      field: 'shipmentId',
      headerName: 'Shipment ID',
      flex: 0.3,
      renderCell: (params: GridRenderCellParams) => {
        return (
          params.row?.hasPermission ? 
            <Link 
              href={`/shipments/${params.row.shipmentId}`} 
              onClick={()=> {
                selectedShipmentId(params.row.shipmentId);
                window.open(`/shipments/${params.row.shipmentId}`, '_blank');
              }}
            >
              {params.row.shipmentId}
            </Link>
            :
            params.row.shipmentId
        );
      }
    },    
    {
      field: 'sendDate',
      headerName: 'Send Date',
      flex: 0.3,
      valueGetter: (_value, row) => formatDateOnly(row.sentDate)
    },
    {
      field: 'connote',
      headerName: 'Connote',
      flex: 0.5,
      valueGetter: (_value, row) => row.connote
    },
    {
      field: 'lastTrackingEvent',
      headerName: 'Last Tracking Event',
      flex: 0.35,
      valueGetter: (_value, row) => row?.lastTrackingEvent && new Date(row.lastTrackingEvent)
    },
    {
      field: 'totalQuantity',
      headerName: 'Total Quantity',
      flex: 0.3,
      valueGetter: (_value, row) => row.totalQty
    },
  ];

  return (
    <PageContainer>
      <Accordian title={
        <Grid container justifyContent="space-between">
          <Grid>
            <Typography>Incoming Shipments</Typography>
          </Grid>
        </Grid>
      } defaultExpanded={true}>
        <GridContainer>
          <DataGrid
            columns={columns}
            rows={incomingShipments}
            getRowId={(row) => row?.shipmentId}
            disableColumnFilter={true}
            disableColumnSelector={true}
            disableDensitySelector={true}
            loading={isLoading}
            componentsProps={{
              toolbar: {
                csvOptions: { disableToolbarButton: true },
                printOptions: { disableToolbarButton: true },
                showQuickFilter: false
              }
            }}
            initialState={{
              sorting: {
                sortModel: [{ field: 'shipmentId', sort: DatagridSortingTypes.Ascending }],
              },
            }}
            onCellClick={(params: any) => selectedShipmentId(params.id)}
            getRowHeight={() => 'auto'}
          />
        </GridContainer>
      </Accordian>
    </PageContainer>
  );
};